import React, { useEffect, useRef, useState } from 'react';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { useFormik } from 'formik';
import { useDispatch } from 'react-redux';
import baseURL, { endPoints } from '../../../Config';
import { Button } from 'primereact/button';
import * as Yup from 'yup';
import { InputText } from 'primereact/inputtext';
import { useLocation, useNavigate } from 'react-router-dom';
import { handleGetRequest } from '../../../service/GetTemplate';
import { handlePutRequest } from '../../../service/PutTemplate';

const EditMerchant = () => {
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [form29File, setForm29File] = useState(null);
    const [ntnNumberFile, setNtnNumberFile] = useState(null);
    const [idCardFrontFile, setIdCardFrontFile] = useState(null);
    const [idCardBackFile, setIdCardBackFile] = useState(null);
    const [ownerPictureFile, setOwnerPictureFile] = useState(null);
    const [form29FileLink, setForm29FileLink] = useState(null);
    const [ntnNumberFileLink, setNtnNumberFileLink] = useState(null);
    const [idCardFrontFileLink, setIdCardFrontFileLink] = useState(null);
    const [idCardBackFileLink, setIdCardBackFileLink] = useState(null);
    const [ownerPictureFileLink, setOwnerPictureFileLink] = useState(null);

    const location = useLocation();
    const navigate = useNavigate();
    const { rowData } = location.state || {};
    const formData = new FormData();

    const user = JSON.parse(localStorage.getItem('adminUser') || '{}');

    const validationSchema = Yup.object().shape({
        POCName: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required')
            .matches(/^[a-zA-Z0-9\s]*$/, 'Owner Name must contain only alphanumeric values'),

        POCEmail: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .email('Invalid email')
            .required('This field is required'),

        CompanyName: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('This field is required')
            .matches(/^[a-zA-Z0-9\s]*$/, 'Company Name must contain only alphanumeric values'),

        CompanyEmail: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .email('Invalid email')
            .required('This field is required'),
        CompanyWebsiteLink: Yup.string()
            .trim()
            .matches(/^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/.*)?$/, 'Invalid website URL')
            .required('This field is required'),

        OwnerPicture: Yup.string().required('This field is required'),
        Form29: Yup.string().required('This field is required'),
        NTNNumber: Yup.string().required('This field is required'),
        IDCardFront: Yup.string().required('This field is required'),
        IDCardBack: Yup.string().required('This field is required')
    });

    const stateSetters = {
        OwnerPicture: setOwnerPictureFile,
        Form29: setForm29File,
        NTNNumber: setNtnNumberFile,
        IDCardFront: setIdCardFrontFile,
        IDCardBack: setIdCardBackFile
    };

    const dispatch = useDispatch();

    const ownerPictureRef = useRef(null);
    const form29ImageRef = useRef(null);
    const ntnImageRef = useRef(null);
    const cnicFrontImageRef = useRef(null);
    const cnicBackImageRef = useRef(null);

    const handleOwnerIconClick = () => ownerPictureRef.current.click();
    const handleNtnIconClick = () => ntnImageRef.current.click();
    const handleIdCardFrontClick = () => cnicFrontImageRef.current.click();
    const handleIdCardBackClick = () => cnicBackImageRef.current.click();
    const handleForm29Click = () => form29ImageRef.current.click();

    const handleFileChange = (event, fieldKey) => {
        const selectedFile = event.target.files[0];

        formik.setFieldValue(fieldKey, selectedFile?.name);
        stateSetters[fieldKey](selectedFile);
    };

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            id: '',
            POCName: '',
            POCEmail: '',
            CompanyName: '',
            CompanyEmail: '',
            POCPhone: '',
            OwnerPicture: '',
            Form29: '',
            NTNNumber: '',
            IDCardFront: '',
            IDCardBack: '',
            CreatedBy: '',
            CompanyWebsiteLink: ''
        },

        onSubmit: async (data) => {
            setLoadingBtn(true);
            formData.append('Id', data?.id || '');
            formData.append('POCName', data?.POCName || '');
            formData.append('POCEmail', data?.POCEmail || '');
            formData.append('CompanyName', data?.CompanyName || '');
            formData.append('CompanyEmail', data?.CompanyEmail || '');
            formData.append('CompanyWebsiteLink', data?.CompanyWebsiteLink || '');
            formData.append('POCPhone', data?.POCPhone || '');
            formData.append('CreatedBy', user?.data?.userId || '');
            formData.append('IsDraft', false);

            if (form29File) formData.append('Form29', form29File);
            if (ntnNumberFile) formData.append('NTNNumber', ntnNumberFile);
            if (idCardFrontFile) formData.append('IDCardFront', idCardFrontFile);
            if (idCardBackFile) formData.append('IDCardBack', idCardBackFile);
            if (ownerPictureFile) formData.append('OwnerPicture', ownerPictureFile);

            const response = await dispatch(handlePutRequest(formData, endPoints.updateMerchant, true));
            if (response?.status === 200) {
                formik.resetForm();
            }
            setLoadingBtn(false);
        }
    });
    const downloadFile = (file, fileName) => {
        if (!file) return;
        const url = URL.createObjectURL(file);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName || 'download';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };
    const fileLinkDownload = (fileLink) => {
        if (!fileLink) return;
        const a = document.createElement('a');
        a.href = fileLink;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    const getMerchantbyId = async () => {
        setLoadingBtn(true);
        const response = await handleGetRequest(endPoints.getMerchantById(rowData.id), true);
        if (response) {
            formik.setFieldValue('id', response?.data?.id);
            formik.setFieldValue('status', response?.data?.status);
            formik.setFieldValue('POCName', response?.data?.pocName);
            formik.setFieldValue('POCEmail', response?.data?.pocEmail);
            formik.setFieldValue('ownerPassword', response?.data?.ownerPassword);
            formik.setFieldValue('CompanyName', response?.data?.companyName);
            formik.setFieldValue('CompanyEmail', response?.data?.companyEmail);
            formik.setFieldValue('CompanyWebsiteLink', response?.data?.companyWebsiteLink);
            formik.setFieldValue('POCPhone', response?.data?.pocContactNumber);
            formik.setFieldValue('Form29', response?.data?.form29);
            setForm29FileLink(response?.data?.form29);
            setIdCardBackFileLink(response?.data?.idCardBack);
            setIdCardFrontFileLink(response?.data?.idCardFront);
            setOwnerPictureFileLink(response?.data?.ownerPicture);
            setNtnNumberFileLink(response?.data?.ntnNumber);
            formik.setFieldValue('NTNNumber', response?.data?.ntnNumber);
            formik.setFieldValue('IDCardFront', response?.data?.idCardFront);
            formik.setFieldValue('IDCardBack', response?.data?.idCardBack);
            formik.setFieldValue('OwnerPicture', response?.data?.ownerPicture);
        }
        setLoadingBtn(false);
    };

    useEffect(() => {
        getMerchantbyId();
    }, [rowData]);

    const getPreviewSrc = (file, link) => {
        if (file) {
            return URL.createObjectURL(file);
        }
        return link;
    };


    const imageBoxStyle = {
        width: '150px',
        height: '150px',
        border: '1px solid #dcdcdc',
        borderRadius: '6px',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f9f9f9'
    };

    const imageStyle = {
        width: '100%',
        height: '100%',
        objectFit: 'cover'
    };

    const changeBtnStyle = {
        marginTop: '0.5rem',
        fontSize: '0.75rem'
    };


    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="p-4">
                <div className="flex justify-content-between align-items-center mb-3">
                    <h3>Edit Merchant</h3>
                </div>
                <div className="grid p-fluid">
                    <div className="col-12 md:col-12 border-bottom-1 mb-2 font-semibold">POC Info</div>
                    <div className="col-12 md:col-4">
                        <div className="field mb-3">
                            <label htmlFor="POCName">POC Name</label>
                            <InputText id="POCName" name="POCName" placeholder="Enter Owner Name" value={formik?.values?.POCName} maxLength={30} onChange={formik.handleChange} />
                            {formik.touched.POCName && formik.errors.POCName && <small className="p-error">{formik.errors.POCName}</small>}
                        </div>
                    </div>
                    <div className="col-12 md:col-4">
                        <div className="field mb-3">
                            <label htmlFor="POCEmail">POC Email</label>
                            <InputText id="POCEmail" name="POCEmail" placeholder="Enter Owner Email" value={formik?.values?.POCEmail} maxLength={30} onChange={formik.handleChange} />
                            {formik.touched.POCEmail && formik.errors.POCEmail && <small className="p-error">{formik.errors.POCEmail}</small>}
                        </div>
                    </div>
                    <div className="col-12 md:col-4">
                        <div className="field mb-3">
                            <label htmlFor="POCPhone">POC Phone</label>
                            <InputText id="POCPhone" name="POCPhone" placeholder="Enter Owner Phone" value={formik?.values?.POCPhone} maxLength={30} onChange={formik.handleChange} />
                            {formik.touched.POCPhone && formik.errors.POCPhone && <small className="p-error">{formik.errors.POCPhone}</small>}
                        </div>
                    </div>
                    <div className="col-12 md:col-12 border-bottom-1 mb-2 font-semibold">Company Info</div>
                    <div className="col-12 md:col-4">
                        <div className="field mb-3">
                            <label htmlFor="CompanyName">Company Name</label>
                            <InputText id="CompanyName" name="CompanyName" placeholder="Enter Company Name" value={formik?.values?.CompanyName} maxLength={30} onChange={formik.handleChange} />
                            {formik.touched.CompanyName && formik.errors.CompanyName && <small className="p-error">{formik.errors.CompanyName}</small>}
                        </div>
                    </div>
                    <div className="col-12 md:col-4">
                        <div className="field mb-3">
                            <label htmlFor="CompanyEmail">Company Email</label>
                            <InputText id="CompanyEmail" name="CompanyEmail" placeholder="Enter Company Email" value={formik?.values?.CompanyEmail} maxLength={30} onChange={formik.handleChange} />
                            {formik.touched.CompanyEmail && formik.errors.CompanyEmail && <small className="p-error">{formik.errors.CompanyEmail}</small>}
                        </div>
                    </div>
                    <div className="col-12 md:col-4">
                        <div className="field mb-3">
                            <label htmlFor="CompanyWebsiteLink">Company Website Link</label>
                            <InputText id="CompanyWebsiteLink" name="CompanyWebsiteLink" placeholder="Enter Company Website Link" value={formik?.values?.CompanyWebsiteLink} maxLength={30} onChange={formik.handleChange} />
                            {formik.touched.CompanyWebsiteLink && formik.errors.CompanyWebsiteLink && <small className="p-error">{formik.errors.CompanyWebsiteLink}</small>}
                        </div>
                    </div>
                    {/* <div className="col-12 md:col-4"></div> */}
                    <div className="col-12 md:col-3">
                        <div className="mb-3">
                            <div className="field">
                                <label htmlFor="image">Upload Form 29</label>
                                <div className="flex flex-column align-items-center gap-2">
                                    {getPreviewSrc(form29File, form29FileLink) ? (
                                        <div style={imageBoxStyle}>
                                            <img
                                                src={getPreviewSrc(form29File, form29FileLink)}
                                                alt="Form 29"
                                                style={imageStyle}
                                            />
                                        </div>
                                    ) : (
                                        <small>No Image</small>
                                    )}

                                    <Button
                                        label="Change Image"
                                        type="button"
                                        size="small"
                                        outlined
                                        style={changeBtnStyle}
                                        onClick={handleForm29Click}
                                    />

                                    <input
                                        type="file"
                                        accept="image/*"
                                        ref={form29ImageRef}
                                        style={{ display: 'none' }}
                                        onChange={(e) => handleFileChange(e, 'Form29')}
                                    />
                                </div>

                                {/* <div className="file-input-container file-input-wrapper w-100" onClick={handleForm29Click}>
                                    <input type="file" accept="image/*" style={{ display: 'none' }} ref={form29ImageRef} onChange={(e) => handleFileChange(e, 'Form29')} className="file-input-field" />
                                    <input type="text" placeholder="Choose a file..." value={formik?.values?.Form29} readOnly className="file-input-field" />
                                </div>
                                {formik.touched.Form29 && formik.errors.Form29 ? <small className="p-error">{formik.errors.Form29}</small> : ''} */}
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-12 md:col-1">
                        <div className="mt-5">
                            <Button
                                icon="pi pi-arrow-down"
                                tooltip="Download File"
                                rounded
                                aria-label="Download"
                                type="button"
                                onClick={() => {
                                    if (form29File) downloadFile(form29File, formik?.values?.Form29);
                                    else if (form29FileLink) fileLinkDownload(form29FileLink);
                                }}
                                disabled={!form29File && !formik?.values?.Form29}
                            />
                        </div>
                    </div> */}
                    <div className="col-12 md:col-3">
                        <div className="mb-3">
                            <div className="field">
                                <label htmlFor="image">Upload NTN Number</label>
                                <div className="flex flex-column align-items-center gap-2">
                                    {getPreviewSrc(ntnNumberFile, ntnNumberFileLink) ? (
                                        <div style={imageBoxStyle}>
                                            <img
                                                src={getPreviewSrc(ntnNumberFile, ntnNumberFileLink)}
                                                alt="NTN Number"
                                                style={imageStyle}
                                            />
                                        </div>
                                    ) : (
                                        <small>No Image</small>
                                    )}

                                    <Button
                                        label="Change Image"
                                        type="button"
                                        size="small"
                                        outlined
                                        style={changeBtnStyle}
                                        onClick={handleNtnIconClick}
                                    />

                                    <input
                                        type="file"
                                        accept="image/*"
                                        ref={ntnImageRef}
                                        style={{ display: 'none' }}
                                        onChange={(e) => handleFileChange(e, 'NTNNumber')}
                                    />
                                </div>

                                {/* <div className="file-input-container file-input-wrapper w-100" onClick={handleNtnIconClick}>
                                    <input type="file" accept="image/*" style={{ display: 'none' }} ref={ntnImageRef} onChange={(e) => handleFileChange(e, 'NTNNumber')} className="file-input-field" />
                                    <input type="text" placeholder="Choose a file..." value={formik?.values?.NTNNumber} readOnly className="file-input-field" />
                                </div>
                                {formik.touched.NTNNumber && formik.errors.NTNNumber ? <small className="p-error">{formik.errors.NTNNumber}</small> : ''} */}
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-12 md:col-1">
                        <div className="mt-5">
                            <Button
                                icon="pi pi-arrow-down"
                                rounded
                                type="button"
                                aria-label="Download NTN"
                                onClick={() => {
                                    if (ntnNumberFile) downloadFile(ntnNumberFile, formik?.values?.NTNNumber);
                                    else if (ntnNumberFileLink) fileLinkDownload(ntnNumberFileLink);
                                }}
                                disabled={!ntnNumberFile && !formik?.values?.NTNNumber}
                                tooltip="Download File"
                            />
                        </div>
                    </div> */}
                    <div className="col-12 md:col-3">
                        <div className="mb-3">
                            <div className="field">
                                <label htmlFor="image">Upload CNIC Front</label>
                                <div className="flex flex-column align-items-center gap-2">
                                    {getPreviewSrc(idCardFrontFile, idCardFrontFileLink) ? (
                                        <div style={imageBoxStyle}>
                                            <img
                                                src={getPreviewSrc(idCardFrontFile, idCardFrontFileLink)}
                                                alt="CNIC Front"
                                                style={imageStyle}
                                            />
                                        </div>
                                    ) : (
                                        <small>No Image</small>
                                    )}

                                    <Button
                                        label="Change Image"
                                        type="button"
                                        size="small"
                                        outlined
                                        style={changeBtnStyle}
                                        onClick={handleIdCardFrontClick}
                                    />

                                    <input
                                        type="file"
                                        accept="image/*"
                                        ref={cnicFrontImageRef}
                                        style={{ display: 'none' }}
                                        onChange={(e) => handleFileChange(e, 'IDCardFront')}
                                    />
                                </div>

                                {/* <div className="file-input-container file-input-wrapper w-100" onClick={handleIdCardFrontClick}>
                                    <input type="file" accept="image/*" style={{ display: 'none' }} ref={cnicFrontImageRef} onChange={(e) => handleFileChange(e, 'IDCardFront')} className="file-input-field" />
                                    <input type="text" placeholder="Choose a file..." value={formik?.values?.IDCardFront} readOnly className="file-input-field" />
                                </div>
                                {formik.touched.IDCardFront && formik.errors.IDCardFront ? <small className="p-error">{formik.errors.IDCardFront}</small> : ''} */}
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-12 md:col-1">
                        <div className="mt-5">
                            <Button
                                icon="pi pi-arrow-down"
                                rounded
                                type="button"
                                aria-label="Download CNIC Front"
                                // onClick={() => downloadFile(idCardFrontFile, formik?.values?.IDCardFront)}
                                onClick={() => {
                                    if (idCardFrontFile) downloadFile(idCardFrontFile, formik?.values?.IDCardFront);
                                    else if (idCardFrontFileLink) fileLinkDownload(idCardFrontFileLink);
                                }}
                                disabled={!idCardFrontFile && !formik?.values?.IDCardFront}
                                tooltip="Download File"
                            />
                        </div>
                    </div> */}
                    <div className="col-12 md:col-3">
                        <div className="mb-3">
                            <div className="field">
                                <label htmlFor="image">Upload CNIC Back</label>
                                <div className="flex flex-column align-items-center gap-2">
                                    {getPreviewSrc(idCardBackFile, idCardBackFileLink) ? (
                                        <div style={imageBoxStyle}>
                                            <img
                                                src={getPreviewSrc(idCardBackFile, idCardBackFileLink)}
                                                alt="CNIC Back"
                                                style={imageStyle}
                                            />
                                        </div>
                                    ) : (
                                        <small>No Image</small>
                                    )}

                                    <Button
                                        label="Change Image"
                                        type="button"
                                        size="small"
                                        outlined
                                        style={changeBtnStyle}
                                        onClick={handleIdCardBackClick}
                                    />

                                    <input
                                        type="file"
                                        accept="image/*"
                                        ref={cnicBackImageRef}
                                        style={{ display: 'none' }}
                                        onChange={(e) => handleFileChange(e, 'IDCardBack')}
                                    />
                                </div>

                                {/* <div className="file-input-container file-input-wrapper w-100" onClick={handleIdCardBackClick}>
                                    <input type="file" accept="image/*" style={{ display: 'none' }} ref={cnicBackImageRef} onChange={(e) => handleFileChange(e, 'IDCardBack')} className="file-input-field" />
                                    <input type="text" placeholder="Choose a file..." value={formik?.values?.IDCardBack} readOnly className="file-input-field" />
                                </div>
                                {formik.touched.IDCardBack && formik.errors.IDCardBack ? <small className="p-error">{formik.errors.IDCardBack}</small> : ''} */}
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-12 md:col-1">
                        <div className="mt-5">
                            <Button
                                icon="pi pi-arrow-down"
                                rounded
                                type="button"
                                aria-label="Download CNIC Back"
                                // onClick={() => downloadFile(idCardBackFile, formik?.values?.IDCardBack)}
                                onClick={() => {
                                    if (idCardBackFile) downloadFile(idCardBackFile, formik?.values?.IDCardBack);
                                    else if (idCardBackFileLink) fileLinkDownload(idCardBackFileLink);
                                }}
                                disabled={!idCardBackFile && !formik?.values?.IDCardBack}
                                tooltip="Download File"
                            />
                        </div>
                    </div> */}
                    <div className="col-12 md:col-3">
                        <div className="mb-3">
                            <div className="field">
                                <label htmlFor="image">Upload Picture</label>
                                <div className="flex flex-column align-items-center gap-2">
                                    {getPreviewSrc(ownerPictureFile, ownerPictureFileLink) ? (
                                        <div style={imageBoxStyle}>
                                            <img
                                                src={getPreviewSrc(ownerPictureFile, ownerPictureFileLink)}
                                                alt="Owner Picture"
                                                style={imageStyle}
                                            />
                                        </div>
                                    ) : (
                                        <small>No Image</small>
                                    )}

                                    <Button
                                        label="Change Image"
                                        type="button"
                                        size="small"
                                        outlined
                                        style={changeBtnStyle}
                                        onClick={handleOwnerIconClick}
                                    />

                                    <input
                                        type="file"
                                        accept="image/*"
                                        ref={ownerPictureRef}
                                        style={{ display: 'none' }}
                                        onChange={(e) => handleFileChange(e, 'OwnerPicture')}
                                    />
                                </div>

                                {/* <div className="file-input-container file-input-wrapper w-100" onClick={handleOwnerIconClick}>
                                    <input type="file" accept="image/*" style={{ display: 'none' }} ref={ownerPictureRef} onChange={(e) => handleFileChange(e, 'OwnerPicture')} className="file-input-field" />
                                    <input type="text" placeholder="Choose a file..." value={formik?.values?.OwnerPicture} readOnly className="file-input-field" />
                                </div>
                                {formik.touched.OwnerPicture && formik.errors.OwnerPicture ? <small className="p-error">{formik.errors.OwnerPicture}</small> : ''} */}
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-12 md:col-1">
                        <div className="mt-5">
                            <Button
                                icon="pi pi-arrow-down"
                                rounded
                                type="button"
                                aria-label="Download Owner Picture"
                                // onClick={() => downloadFile(ownerPictureFile, formik?.values?.OwnerPicture)}
                                onClick={() => {
                                    if (ownerPictureFile) downloadFile(ownerPictureFile, formik?.values?.OwnerPicture);
                                    else if (ownerPictureFileLink) fileLinkDownload(ownerPictureFileLink);
                                }}
                                disabled={!ownerPictureFile && !formik?.values?.OwnerPicture}
                                tooltip="Download File"
                            />
                        </div>
                    </div> */}
                </div>
                <div className="flex justify-content-center mt-4 gap-2">
                    <Button label="Update" icon="pi pi-pencil" type="submit" disabled={loadingBtn} className="p-button-success p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} />
                    <Button label="Cancel" icon="pi pi-file-o" type="button" className="p-button-secondary p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} onClick={() => navigate('/merchant-list')} />
                </div>
            </div>
        </form>
    );
};

export default EditMerchant;
